import { addDays } from "date-fns";
import { DateRangeType, DurationTimeframeTypeEnum } from "../../enums/DRCXEnums";

export interface IDRCXTimeAndDuration {
    durationType: DurationTimeframeTypeEnum;

    // durationType == SpecificStartOrStop
    fixedStartDate: Date | undefined;
    fixedStartDateRangeType: DateRangeType | undefined;
    fixedEndDate: Date | undefined;
    fixedEndDateRangeType: DateRangeType | undefined;

    // durationType == MultipleTimeFrames
    multipleStartOffset: number | undefined;
    multipleStartRangeType: DateRangeType | undefined;
    multipleDuration: number | undefined;
    multipleDurationRangeType: DateRangeType | undefined;

    // durationType == CurrentSingleTimeFrame
    currentRangeType: DateRangeType | undefined;

    // durationType == PreviousSingleTimeFrame
    previousRangeType: DateRangeType | undefined;

    runToCurrentDate: boolean | undefined;
    currentDateOffset: number | undefined;
    currentDateRangeType: DateRangeType | undefined;
}

// #endregion Base Interfaces

// #region Base Classes

export class DRCXTimeAndDuration implements IDRCXTimeAndDuration {
    public durationType: DurationTimeframeTypeEnum = DurationTimeframeTypeEnum.MultipleTimeFrames;

    // durationType == SpecificStartOrStop
    public fixedStartDate: Date | undefined = addDays(new Date(), -7);
    public fixedStartDateRangeType: DateRangeType = DateRangeType.Raw;
    public fixedEndDate: Date = new Date();
    public fixedEndDateRangeType: DateRangeType = DateRangeType.Raw;

    // durationType == MultipleTimeFrames
    public multipleStartOffset: number | undefined = -6;
    public multipleStartRangeType: DateRangeType = DateRangeType.Day;
    public multipleDuration: number | undefined = 7;
    public multipleDurationRangeType: DateRangeType = DateRangeType.Day;

    // durationType == CurrentSingleTimeFrame
    public currentRangeType: DateRangeType = DateRangeType.Month;

    // durationType == PreviousSingleTimeFrame
    public previousRangeType: DateRangeType = DateRangeType.Hour;

    public runToCurrentDate: boolean = false;
    public currentDateOffset: number = 0;
    public currentDateRangeType: DateRangeType | undefined = undefined;
}
